/**
 * Hardcoded feature flag for the eGO area.
 * Set to true to show the eGO navigation card on the Dashboard.
 * Routes remain accessible regardless of this value.
 *
 * Requirements: 1.1, 1.4
 */
export const EGO_FEATURE_ENABLED = false;
